// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/ActionsAction/Content/Content/DeleteAction/Confirmation/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_ActionsAction_Content_Content_DeleteAction_Confirmation_Content($ids: [numeric!]!) {
  delete_vaxiom_procedure_steps(where: { procedure: { id: { _in: $ids } } }) {
    affected_rows
  }
  delete_vaxiom_procedure_misc_fee_charge_templates(
    where: { procedure_id: { _in: $ids } }
  ) {
    affected_rows
  }
  delete_vaxiom_procedures(where: { id: { _in: $ids } }) {
    affected_rows
  }
}

`